<div class="p-3">
  <p class="is-bold is-size-5 color-darkblue has-text-centered mb-4">
    Jetzt noch schneller: Flurstücke auswählen - so geht's:
  </p>

  <p class="mb-4">
    Einfach Adresse eingeben und passende Flurstücke direkt auf der interaktiven Karte anklicken. Mehrfachauswahl ist möglich.
  </p>

  <div class="is-flex is-justify-content-center">
    <img class="map-gif" src="assets/images/map/map_demo.gif" alt="Karten-Auswahl Demo">
  </div>


  <div class="warning-container my-4">
    <p class="mb-4">
      <span class="is-bold color-darkblue">Wichtig:</span> Bitte nur Flurstücke markieren, für die ein berechtigtes Interesse besteht – andernfalls kann die Behörde die Anfrage ablehnen.
    </p>

    <p>Sie sind sich nicht sicher, welche Flurstücke zum Grundstück/Immobilie gehören? Gerne unterstützen wir Sie mit unserem Analyse-Service.</p>
  </div>

  <p class="mb-4">
    <span class="is-bold color-darkblue">Alternativ:</span> Die manuelle Eingabe steht weiterhin zur Verfügung. Einfach auf „Manuell" klicken.
  </p>

  <p>
    Bei Fragen oder Unsicherheiten steht Ihnen unser Support-Team gerne zur Verfügung.
  </p>

  <div class="columns mt-3 is-variable is-multiline">
    <div class="column is-one-third is-hidden-mobile"></div>
    <div class="column is-one-third is-hidden-mobile"></div>

    <div (click)="closeModal()" class="column is-one-third is-full-mobile">
      <a class="no-border buy-button is-size-6 has-round-border has-text-centered">
        <div class="columns is-mobile full-width">
          <div class="column is-12 is-bold relative">
            <p>Verstanden</p>
          </div>
        </div>
      </a>
    </div>
  </div>

</div>
